import React, { useState } from "react";
import { Search, X, Loader2 } from "lucide-react";

interface SearchBarProps {
  onSearch: (query: string) => void;
  loading: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({ onSearch, loading }) => {
  const [queryText, setQueryText] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!queryText.trim()) return;
    onSearch(queryText.trim());
  };

  const handleClear = () => {
    setQueryText("");
  };

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <div className="relative flex items-center">
        <div className="absolute left-4 text-text-muted pointer-events-none">
          <Search className="w-5 h-5" />
        </div>

        <input
          type="text"
          value={queryText}
          onChange={(e) => setQueryText(e.target.value)}
          placeholder="Search artist, song title, or karaoke track..."
          className="w-full pl-12 pr-28 py-3.5 bg-card border border-border focus:border-primary rounded-2xl text-text-main placeholder-text-muted text-sm shadow-md outline-none transition-all"
        />

        <div className="absolute right-2 flex items-center gap-1.5">
          {queryText && (
            <button
              type="button"
              onClick={handleClear}
              className="p-1.5 rounded-full hover:bg-border/40 text-text-muted hover:text-text-main transition-colors cursor-pointer"
            >
              <X className="w-4 h-4" />
            </button>
          )}

          <button
            type="submit"
            disabled={loading || !queryText.trim()}
            className="py-2 px-4 rounded-xl bg-primary hover:bg-primary-hover text-white text-xs font-bold flex items-center gap-1.5 transition-all shadow-md cursor-pointer disabled:opacity-50"
          >
            {loading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <span>Search</span>
            )}
          </button>
        </div>
      </div>
    </form>
  );
};
